import { createContext } from 'react';

export type RecordLockHeartbeatContextValue = {
  beginUploadingFiles: () => void;
  endUploadingFiles: () => void;
};

export const RecordLockHeartbeatContext = createContext<RecordLockHeartbeatContextValue | null>(null);
